import apiService from './apiService';

export const getActivity = async (moduleName: string, moduleItemId: number | null) => {
  try {
    let url = `activity-logs?filter[module]=${encodeURIComponent(moduleName)}`;

    if (moduleItemId !== null) {
      url += `&filter[module_item_id]=${encodeURIComponent(moduleItemId)}`;
    }

    const response = await apiService.get(url);

    return response.data.data;
  } catch (error) {
    console.error('Error fetching activity:', error);
    throw error;
  }
};
